import ap from "assets/financieras/AP.png";
import ca from "assets/financieras/CA.png";
import cd from "assets/financieras/CD.png";
import col from "assets/financieras/COL.png";
import cy from "assets/financieras/CY.png";
import rc from "assets/financieras/RC.png";
import yo from "assets/financieras/YO.png";
import sa from "assets/financieras/SA.png";
import nx from "assets/financieras/NX.png";
import ct from "assets/financieras/CT.png";
import cc from "assets/financieras/CC.svg";
import cs from "assets/financieras/CS.svg";

export const financierasBanner = [
  {
    name: "ArgenPesos",
    logo: ap,
    url: "https://www.argenpesos.com.ar/",
  },
  {
    name: "Crédito argentino",
    logo: ca,
    url: "https://www.creditoargentino.com.ar/",
  },
  {
    name: "Crédito directo",
    logo: cd,
    url: "https://www.directo.com.ar/",
  },
  {
    name: "Columbia",
    logo: col,
    url: "https://secure.bancocolumbia.com.ar/web/Prestamos-Personales-10032.note.aspx",
  },
  {
    name: "Cuota Ya",
    logo: cy,
    url: "https://cuotaya.com.ar/",
  },
  {
    name: "Rapicompra",
    logo: rc,
    url: "https://www.macro.com.ar/rapicompra",
  },
  {
    name: "Yolo",
    logo: yo,
    url: "https://yolopago.app/",
  },
  {
    name: "Santander Consumer",
    logo: sa,
    url: "https://www.santanderconsumer.es/",
  },
  {
    name: "Naranja X",
    logo: nx,
    url: "https://www.naranjax.com/",
  },
  {
    name: "CT",
    logo: ct,
    url: "https://ct.com.ar",
  },
  {
    name: "Creditech",
    logo: cc,
    url: "https://creditech.com.ar",
  },
  {
    name: "Carta Sur",
    logo: cs,
    url: "https://www.cartasur.com.ar/",
  },
];
